/* assets/product-video.js.liquid */
(function(window, document, utils) {
  'use strict';
  window.SDG = window.SDG || {};
  
  SDG.productVideo = function(opts) {
    var config = {
      dom: {
        image: 'js-video-image',
        slide: 'js-product-video',
        videoTitle: 'js-video-title',
        videoWrap: 'js-vid-wrap',
        videoPrefix: 'video',
        el: null,
        embedId: null
      },
      cls: { videoPlayed: 'video-played', loadingVimeo: 'loading-vimeo' },
      before_embed: null,
      errorCb: null,
      isBramour: false,
      useTitle: true
    };
    config = utils.extend(config, opts || {});
    var img = config.dom.el ? config.dom.el : document.querySelector('.' + config.dom.image);
    
    function init() {
      getData();
      initVideoEmbed();
    }
    
    function getData() {
      // Replace _.ajax with utils.ajax. The Vimeo token is inserted via Liquid.
      utils.ajax({
        type: 'GET',
        url: 'https://api.vimeo.com/videos/' + img.dataset.id,
        headers: { Authorization: 'bearer ' + '' },
        success: function(resp) {
          insertThumb(img, resp);
          if (!config.isBramour && config.useTitle) insertTitle(img, resp);
        },
        error: function() { if (config.errorCb) { config.errorCb(img); } }
      });
    }
    
    function initVideoEmbed() {
      var beforeEmbed = config.before_embed ? config.before_embed : hideVideoTools;
      var embedId = config.dom.embedId ? config.dom.embedId : config.dom.videoPrefix + img.dataset.id;
      var loopVideo = config.isBramour;
      // Assumes a global SDG.videoEmbed exists.
      if (window.SDG.videoEmbed) {
        var video = window.SDG.videoEmbed({
          id: embedId,
          image: '.' + config.dom.image,
          class: { ir: 'product-video__ir' },
          before_embed: beforeEmbed,
          loop: loopVideo
        });
        video.init();
      }
    }
    
    function insertThumb(imageEl, resp) {
      var sizes = resp.pictures.sizes;
      var retinaImg, largestImg = 0;
      if (config.isBramour) {
        sizes.forEach(function(item) {
          if ((item.width / item.height) < 1 && item.width > largestImg) {
            largestImg = item.width;
            retinaImg = item.link;
          }
        });
      } else {
        sizes.forEach(function(item) {
          if (item.width > largestImg) {
            largestImg = item.width;
            retinaImg = item.link;
          }
        });
      }
      imageEl.setAttribute('data-src', retinaImg);
      utils.removeClass(imageEl, config.cls.loadingVimeo);
    }
    
    function insertTitle(imageEl, resp) {
      var parent = utils.parents(imageEl, '.' + config.dom.slide)[0];
      if (parent) {
        var titleEl = parent.querySelector('.' + config.dom.videoTitle);
        if (titleEl) titleEl.innerText = resp.name;
      }
    }
    
    function hideVideoTools() {
      var parent = utils.parents(img, '.' + config.dom.slide)[0];
      if (parent) {
        utils.addClass(parent, config.cls.videoPlayed);
      }
    }
    
    init();
  };

})(window, document, window.utils);
